import type { ContentBlock } from '@/pages/blog/data';

export default function ArticleContent({ content }: { content: ContentBlock[] }) {
  return (
    <div className="space-y-6 md:space-y-7">
      {content.map((block, index) => {
        switch (block.type) {
          case 'lead':
            return (
              <p
                key={index}
                className="font-heading text-xl md:text-2xl leading-relaxed text-foreground-900 font-medium"
              >
                {block.text}
              </p>
            );
          case 'paragraph':
            return (
              <p key={index} className="text-base md:text-[17px] leading-[1.85] text-foreground-700">
                {block.text}
              </p>
            );
          case 'heading':
            return (
              <h2
                key={index}
                className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 leading-snug pt-6 md:pt-8"
              >
                {block.text}
              </h2>
            );
          case 'quote':
            return (
              <blockquote
                key={index}
                className="relative pl-6 md:pl-8 py-2 border-l-2 border-accent-400"
              >
                <p className="font-heading text-xl md:text-2xl italic text-foreground-900 leading-relaxed">
                  “{block.text}”
                </p>
                {block.cite && (
                  <footer className="mt-3 text-sm text-foreground-500 not-italic">
                    — {block.cite}
                  </footer>
                )}
              </blockquote>
            );
          case 'numbered':
            return (
              <div key={index} className="flex gap-4 md:gap-5">
                <span className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-accent-100 text-accent-800 text-sm md:text-base font-medium flex items-center justify-center mt-1">
                  {index + 1}
                </span>
                <p className="text-base md:text-[17px] leading-[1.85] text-foreground-700">
                  <span className="font-semibold text-foreground-900">{block.title}</span>{' '}
                  {block.text}
                </p>
              </div>
            );
          case 'closing':
            return (
              <p
                key={index}
                className="font-heading text-lg md:text-xl italic leading-relaxed text-foreground-900 pt-4"
              >
                {block.text}
              </p>
            );
          case 'signature':
            return (
              <p
                key={index}
                className="text-base md:text-[17px] leading-relaxed text-foreground-600 pt-4 whitespace-pre-line"
              >
                {block.text}
              </p>
            );
          default:
            return null;
        }
      })}
    </div>
  );
}